import React, { useEffect, useMemo } from 'react';
import { useState } from 'react';
import {
  Divider,
  TextField,
  Grid,
  Typography,
  Button,
  Select,
  MenuItem,
  FormControl,
  ListSubheader,
  InputAdornment
} from '@mui/material';
import ConfirmationModal from 'src/content/common/confirmationModal/ConfirmationModal';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { PromoteDesignation } from 'src/models/employee';
import {
  getAllBillingRoles,
  updateDesignation
} from 'src/services/employeeService';
import { AppActions } from 'src/store/AppReducer';
import moment from 'moment';
import { useAppSelector } from 'src/hooks/hooks';
import SearchIcon from '@mui/icons-material/Search';
import { DatePicker } from '@mui/lab';
import Checkbox from '@mui/material/Checkbox';

const PromoteForm = ({ getData, handleClose, empId, lastPromotedDate, latestPosition }) => {
  const { register, handleSubmit, reset } = useForm<PromoteDesignation>();
  const dispatch = useDispatch();

  const [billingRoles, setBillingRoles] = useState<any>([]);

  useEffect(() => {
    getAllBillingRoles().then((res) => setBillingRoles(res.data));
  }, []);

  const [userData, setUserData] = useState<any>({});

  const containsText = (text, searchText) =>
    text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

  const [searchText, setSearchText] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isWorkingCurrentRole, setIsWorkingCurrentRole] = useState<boolean>(true);

  const displayedDesignation = useMemo(
    () =>
    billingRoles?.filter((option) => containsText(option.name, searchText)),
    [searchText, billingRoles]
  );

  const onSubmit = () => {
    const data: any = userData;
    dispatch(AppActions.showLoader());
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    data.promotedEmployeeId = user.EmployeeId;

    data.employeeId = empId;

    let today: any = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = today.getFullYear();

    today = yyyy + '-' + mm + '-' + dd;

    data.PromotingdDate = today;
    data.endDate = endDate ? endDate : null;

    updateDesignation(data)
      .then((res) => {
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: 'Designation added successfully',
            severity: 'success'
          })
        );
        getData();
        dispatch(AppActions.hideLoader());
      })
      .catch((err) => {
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: 'Unable to added Designation the Employee',
            severity: 'error'
          })
        );
        dispatch(AppActions.hideLoader());
      });
    getData();
    handleClose();
   };

  const TextFieldStyle = {
    paddingTop: 10,
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: '13px'
  };

  const LabelStyle = {
    paddingTop: 10,
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: '13px'
  };

  const selectStyle = {
    width: '94%',
    marginLeft: 10,
    marginTop: 10,
    paddingRight: 10,
    fontSize: '13px'
  };

  const [isOpen, setIsOpen] = useState(false);
  const [errors, setErrors] = useState({
    nameError: '',
    tierError: '',
    startDateError: '',
    endDateError: '',
    feedbackError: ''
  });

  const toggle = () => {
    const errorData: any = {};

    if (!userData.name) {
      errorData.nameError = 'Designation Required';
    }
    if (!userData.tier) {
      errorData.tierError = 'Tier Required';
    }
    if (!userData.startingDate) {
      errorData.startDateError = 'Starting Date Required';
    }
    // if (Date.parse(lastPromotedDate) >= Date.parse(userData.startingDate)) {
    //   errorData.dateError =
    //     'Starting date should be greater than last promotion date';
    // }

    setErrors(errorData);
    if (Object.keys(errorData).length === 0) {
      setIsOpen(!isOpen);
    }
  };

  const handleIsWorkingCurrentRole = () => {
    setIsWorkingCurrentRole(!isWorkingCurrentRole);
    setEndDate('');
    setUserData((prev) => ({
      ...prev,
      endDate: ''
    }));
  } 

  const [tier, setTier] = useState('');
  const { isLoading } = useAppSelector((state) => state.appReducer);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid sx={{ px: 2, mt: '0.5rem' }} container spacing={2}>
        <Grid item xs={6}>
          <Typography
            sx={{ pb: 1 }}
            variant="h4"
            style={{
              paddingTop: 10,
              paddingLeft: 10,
              paddingRight: 10,
              fontSize: '15px'
            }}
          >
            Add Designation
          </Typography>
        </Grid>
      </Grid>
      <Grid sx={{ px: 2 }} container spacing={2}>
        <Grid item xs={6}>
          <Typography variant="h5" style={LabelStyle}>
            Designation<span style={{ color: 'red' }}>*</span>
          </Typography>
          <FormControl fullWidth>
            <Select
              id="promote-name"
              MenuProps={{ autoFocus: false }}
              size="small"
              {...register('name', {})}
              style={selectStyle}
              inputProps={{ 'aria-label': 'Without label' }}
              displayEmpty
              defaultValue=""
              onChange={(e) => {
                setErrors((prev) => ({
                  ...prev,
                  nameError: ''
                }));
                setUserData((prev) => ({
                  ...prev,
                  name: e.target.value
                }));
                const obj: any = billingRoles.filter(
                  (fil) => fil.name === e.target.value
                );
                setUserData((prev) => ({
                  ...prev,
                  tier: obj[0]?.tier
                }));
                setTier(obj[0].tier);
              }}
              onClose={() => setSearchText('')}
          >
            <ListSubheader>
              <TextField
               id="promote-searchName"
               size="small"
               autoFocus
               placeholder="Type to search..."
               fullWidth
               InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== 'Escape') {
                  e.stopPropagation();
                }
              }}
              ></TextField>
            </ListSubheader>
            <MenuItem
                disabled
                selected
                style={{ display: 'none' }}
                value={``}
              >
                Select Designation
              </MenuItem>
              {(displayedDesignation).map((item, i) => {
                return (
                  <MenuItem value={item.name} key={i}>
                    {item.name}
                  </MenuItem>
                );
              })}
          </Select>
            {errors?.nameError && (
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px'
                }}
                color="red"
              >
                {errors?.nameError}&nbsp;
              </Typography>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <Typography style={LabelStyle} variant="h5">
            Tier<span style={{ color: 'red' }}>*</span>
          </Typography>
          <FormControl fullWidth>
            <TextField
              id="promote-tier"
              size="small"
              disabled
              {...register('tier', {})}
              fullWidth
              style={TextFieldStyle}
              placeholder="tier"
              value={tier}
              InputLabelProps={{
                shrink: false
              }}
            />
            {errors?.tierError && (
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px'
                }}
                color="red"
              >
                {errors?.tierError}
              </Typography>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} style={{ display: 'flex'}}>
          <Checkbox checked={isWorkingCurrentRole} onClick={() => handleIsWorkingCurrentRole()} color="primary" />
          <Typography style={LabelStyle} variant="h5" sx={{ marginTop: '4px', marginLeft: '-6px'}}>
           Employee is currently working on this role
          </Typography>
        </Grid>
        <Grid style={{ marginTop: '-1rem' }} item xs={6}>
          <Typography style={LabelStyle} variant="h5">
            Starting Date<span style={{ color: 'red' }}>*</span>
          </Typography>
          <div style={{ marginLeft: 10, marginRight: 8, marginTop: 10}}>
          <FormControl fullWidth>
          <DatePicker
            InputProps={{
              className: 'date-picker'
            }}
            // minDate={new Date(lastPromotedDate)}
            maxDate={endDate ? new Date(endDate) : new Date()}
            renderInput={(params) => <TextField {...params} id="promote-startingDate" />}
            value={startDate ? startDate : null}
            onChange={(newValue) => {
              if (newValue) {
                setErrors((prev) => ({
                  ...prev,
                  startDateError: ''
                }));
                setUserData((prev) => ({
                  ...prev,
                  startingDate: moment(newValue).format('YYYY-MM-DD')
                }));
                setStartDate(moment(newValue).format('YYYY-MM-DD'));
              }
            }}
          />
          </FormControl>
          </div>
          <Typography
            style={{
              paddingLeft: 15,
              paddingRight: 15,
              fontSize: '11px',
              marginBottom: '0.5rem'
            }}
            color="red"
          >
            {errors?.startDateError}&nbsp;
          </Typography>
        </Grid>
        <Grid style={{ marginTop: '-1rem' }} item xs={6}>
          <Typography style={LabelStyle} variant="h5">
            End Date {isWorkingCurrentRole === false && (<span style={{ color: 'red' }}>*</span>)}
          </Typography>
          <div style={{ marginLeft: 10, marginRight: 8, marginTop: 10}}>
          <FormControl fullWidth>
          <DatePicker
            disabled={isWorkingCurrentRole}
            InputProps={{
              className: 'date-picker'
            }}
            minDate={new Date(startDate)}
            maxDate={new Date()}
            renderInput={(params) => <TextField {...params} id="promote-endDate" />}
            value={endDate ? endDate : null}
            onChange={(newValue) => {
              if (newValue) {
                setErrors((prev) => ({
                  ...prev,
                  endDateError: ''
                }));
                setUserData((prev) => ({
                  ...prev,
                  endDate: moment(newValue).format('YYYY-MM-DD')
                }));
                setEndDate(moment(newValue).format('YYYY-MM-DD'));
              }
            }}
          />
          </FormControl>
          </div>
        </Grid>
        {isWorkingCurrentRole && (
          <Grid item xs={12} style={{ display: 'flex', marginTop: '-2rem'}}>
          <Typography style={LabelStyle} variant="h6">
            End current position as of now - {latestPosition}
          </Typography>
        </Grid>
        )}
        <Grid style={{ marginTop: '-0.5rem' }} item xs={12}>
          <Typography style={LabelStyle} variant="h5">
            Feedback
          </Typography>
          <TextField
            id="promote-feedback"
            {...register('feedback', {})}
            onChange={(e) => {
              if (e.target.value.length > 500) {
                setErrors((prev) => ({
                  ...prev,
                  feedbackError: 'Character length should not exceed 500'
                }));
              } else {
                setErrors((prev) => ({
                  ...prev,
                  feedbackError: ''
                }));
              }
              setUserData((prev) => ({
                ...prev,
                feedback: e.target.value
              }));
            }}
            style={{ ...TextFieldStyle }}
            size="medium"
            fullWidth
            placeholder="Enter Feedback"
            variant="outlined"
            multiline={true}
            rows={2}
          />
          <Typography
            style={{
              paddingLeft: 15,
              paddingRight: 15,
              fontSize: '11px'
            }}
            color="red"
          >
            {errors?.feedbackError}&nbsp;
          </Typography>
        </Grid>
      </Grid>

      <Grid sx={{ pt: 2 }} container spacing={2}>
        <Divider />
        <Grid item xs={6}></Grid>

        <Grid
          item
          sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}
          xs={6}
        >
          <Button
            id="btn-promote-handleClose"
            size="small"
            sx={{
              width: '30%',
              background: '#F5F7FF',
              fontSize: '13px',
              fontWeight: 'normal'
            }}
            onClick={() => handleClose()}
          >
            Cancel
          </Button>
          <Button
            id="btn-promote-toggle"
            disabled={
              !userData.name || !userData.tier || !userData.startingDate || (!userData.endDate && isWorkingCurrentRole === false)
            }
            size="small"
            sx={{
              width: '30%',
              ml: 2,
              fontSize: '13px',
              fontWeight: 'normal',
              background: '#0069E4'
            }}
            variant="contained"
            type="button"
            onClick={() => toggle()}
          >
            Save
          </Button>
        </Grid>
      </Grid>
      <ConfirmationModal
        isLoading={isLoading}
        open={isOpen}
        toggle={() => setIsOpen(!isOpen)}
        message={`Are you sure you want to add this designation to this employee?`}
        onConfirm={() => onSubmit()}
        noToggle={() => {
          setIsOpen(!isOpen);
        }}
      />
    </form>
  );
};

export default PromoteForm;
